import { render } from "./Profile.vue?vue&type=template&id=cd3ffc6a"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=cd3ffc6a&lang=css"

import exportComponent from "D:\\project\\idbrand\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__